///import store from "../store";
//import firebase from "firebase";
import db from "../components/firebaseInit";
import axios from "axios";
//import store from "../store";
import APIs from "../components/APIInit";
import store from "@/store";
//import moment from "moment";

export default {
    methods: {
        getSpeakersSessionCount(speakerId) {
            return new Promise((resolve, reject) => {
                var eventCollection = this.getEventCollectionName();
                if (eventCollection) {
                    db.collection(eventCollection)
                        .doc("Settings")
                        .collection("Sessions")
                        .doc("SessionsSettings")
                        .get()
                        .then(async(doc) => {
                            var agendaFilterOption = 0; // 0: FullAgendaOnly (Default), 1: MyAgendaOnly, 2: ShowAll
                            var sessions = [];
                            if (doc.exists) {
                                var data = doc.data();
                                if (data.AgendaFilterOption) {
                                    agendaFilterOption = parseInt(data.AgendaFilterOption);
                                }
                            }
                            db.collection(eventCollection)
                                .doc("SessionList")
                                .collection("Sessions")
                                .where("IsPublished", "==", true)
                                .orderBy("StartDate", "asc")
                                .orderBy("EndDate", "asc")
                                .get()
                                .then(async(querySnapshot) => {
                                    querySnapshot.forEach((doc) => {
                                        var data = doc.data();
                                        var isHost = false;
                                        var isSpeaker = false;
                                        if (data.MappedSpeakers && data.MappedSpeakers.length > 0) {
                                            data.MappedSpeakers.map((speaker) => {
                                                if (speaker.AttendeeId == speakerId) {
                                                    isSpeaker = true;
                                                }
                                            });
                                        }
                                        if (data.MappedHosts && data.MappedHosts.length > 0) {
                                            data.MappedHosts.map((speaker) => {
                                                if (speaker.AttendeeId == speakerId) {
                                                    isSpeaker = true;
                                                    isHost = true;
                                                }
                                            });
                                        }
                                        if (data.MappedCoHost && data.MappedCoHost.length > 0) {
                                            data.MappedCoHost.map((speaker) => {
                                                if (speaker.AttendeeId == speakerId) {
                                                    isSpeaker = true;
                                                    isHost = true;
                                                }
                                            });
                                        }
                                        if (data.StartDate.seconds < data.EndDate.seconds && isSpeaker) {
                                            var session = {};
                                            session.SessionId = data.SessionId;
                                            session.StartTimestamp = data.StartDate.seconds;
                                            session.EndTimestamp = data.EndDate.seconds;
                                            session.Name = data.Name;
                                            session.IsHost = isHost;
                                            session.IsSpeaker = isSpeaker;
                                            session.TrackName = "";
                                            if (data.Track && data.Track.TrackName) {
                                                session.TrackName = data.Track.TrackName;
                                            }
                                            session.StreamingClient = "";
                                            if (data.StreamingClient) {
                                                session.StreamingClient = data.StreamingClient;
                                            }
                                            if (data.Zoom_Detail) {
                                                session.Zoom_Detail = data.Zoom_Detail;
                                            }
                                            session.IsZoomRTMP = false;
                                            if (data.IsZoomRTMP) {
                                                session.IsZoomRTMP = data.IsZoomRTMP;
                                            }
                                            session.ZoomRTMPMUX_detail =
                                                doc.data().ZoomRTMPMUX_detail;
                                            session.ZoomRTMPEnable_Status =
                                                doc.data().ZoomRTMPEnable_Status;
                                            session.ZoomMeetingStarted = doc.data().MeetingStarted ?
                                                doc.data().MeetingStarted :
                                                false;
                                            session.ZoomRTMPStarted = doc.data().ZoomRTMPStarted ?
                                                doc.data().ZoomRTMPStarted :
                                                false;
                                            session.SessionTypeDetails = data.SessionTypeDetails;
                                            sessions.push(session);
                                            //console.log("session?????????????? " + session)
                                        }
                                    });
                                    //alert("agendaFilterOption: " + agendaFilterOption);
                                    //alert("sessions: " + sessions.length);
                                    if (agendaFilterOption == 1) {
                                        var clientId = "";
                                        var client = store.getters.getClient;
                                        if (client) {
                                            clientId = client[0].id;
                                        }
                                        var eventId = store.getters.getEvent;
                                        var token = store.getters.getToken;
                                        let headers = {
                                            "content-type": "application/json",
                                            Authorization: "Bearer " + token,
                                        };
                                        let requestData = {
                                            key: {
                                                instanceId: "OA_UAT",
                                                clientId: clientId,
                                                eventId: eventId,
                                            },
                                            data: {
                                                AttendeeId: speakerId,
                                            },
                                        };
                                        var myAgenda = [];
                                        axios
                                            .post(APIs.MyAgenda, requestData, {
                                                headers: headers,
                                            })
                                            .then(async(responseData) => {
                                                if (
                                                    responseData &&
                                                    responseData.data &&
                                                    responseData.data.status == 0 &&
                                                    responseData.data.sessions
                                                ) {
                                                    responseData.data.sessions.map(function(item) {
                                                        myAgenda.push(item.SessionId);
                                                    });
                                                }

                                                sessions = sessions.filter(function(item) {
                                                    return myAgenda.includes(item.SessionId);
                                                });
                                                //alert("myAgenda: " + sessions.length);
                                                resolve({
                                                    data: sessions,
                                                    Message: "",
                                                    status: 0,
                                                });
                                            })
                                            .catch((error) => {
                                                console.log(error);
                                                reject({
                                                    Message: "System error",
                                                    status: -1,
                                                });
                                            });
                                    } else {
                                        //alert("sessions: " + sessions.length);
                                        resolve({
                                            data: sessions,
                                            Message: "",
                                            status: 0,
                                        });
                                    }
                                })
                                .catch(function(error) {
                                    console.log("getSpeakersSessionCount - SessionList: " + error)
                                    reject({
                                        Message: "System error",
                                        status: -1,
                                    });
                                });
                        })
                        .catch(function(error) {
                            console.log("getSpeakersSessionCount - SessionsSettings: " + error)
                            reject({
                                Message: "System error",
                                status: -1,
                            });
                        });
                } else {
                    reject({
                        Message: "Invalid Request",
                        status: -1,
                    });
                }
            });
        },

        //statisticsGenerator(payload) {
        //    return new Promise(async(resolve, reject) => {
        //        try {
        //            let eventPath = `/OA_UAT/ClientList/Clients/C1591205467009/Events`;
        //            let events = await db.firestore().collection(eventPath).get();
        //            let allEvents = [];
        //            let allEventNames = [];

        //            events.forEach((element) => {
        //                allEventNames.push(element.data().EventFullName);
        //                let sessionData = `/OA_UAT_C1591205467009${element.id}/SessionList/Sessions/`;
        //                allEvents.push(db.firestore().collection(sessionData).get());
        //            });
        //            let sessionData = [];
        //            let startTimer = payload.time * 60 * 60;
        //            //let toEmail = payload.toEmail;
        //            let currentTime = new Date().getTime() / 1000;
        //            let promiseEvants = await Promise.all(allEvents);
        //            promiseEvants.forEach((element, index) => {
        //                if (element.size) {
        //                    element.forEach((session) => {
        //                        var eventName = allEventNames[index];
        //                        let sessionPromiseData = session.data();
        //                        if (eventName != undefined)
        //                            sessionPromiseData.eventName = eventName;
        //                        if (
        //                            sessionPromiseData.EndDate._seconds <= currentTime &&
        //                            sessionPromiseData.StartDate._seconds + startTimer >=
        //                            currentTime &&
        //                            sessionPromiseData.ZoomMeetingId
        //                        )
        //                            sessionData.push(sessionPromiseData);
        //                    });
        //                }
        //            });
        //            let finalCSVDetails = [];
        //            let tempCSVDetails = [];
        //            for (let i = 0; i < sessionData.length; i++) {
        //                let session = sessionData[i];

        //                let zoomDetails = await axios.post(
        //                    "https://zoomapi.e2m.live/getmeetingattendance.php", {
        //                        meetingid: session.ZoomMeetingId,
        //                    }
        //                );

        //                if (zoomDetails.data && zoomDetails.data.participants) {
        //                    zoomDetails.data.participants.forEach((zoomPerson) => {
        //                        if (zoomPerson.user_email != "") {
        //                            var startDate = new Date(session.StartDate._seconds * 1000);
        //                            var endDate = new Date(session.EndDate._seconds * 1000);
        //                            var difference = endDate.getTime() - startDate.getTime();
        //                            var resultInMinutes = Math.round(difference / 60000);

        //                            var tempSessionData = tempCSVDetails.filter(e => {
        //                                return e.MeetingID == session.ZoomMeetingId && e.UserEmail == zoomPerson.user_email
        //                            })
        //                            var duplicateFlg = true;


        //                            if (tempSessionData.length > 0) {
        //                                if (session.ZoomMeetingId == "97252227317") {
        //                                    console.log("ZoomMeetingId=======", session.ZoomMeetingId)
        //                                    console.log("user_email=======", zoomPerson.user_email)
        //                                    console.log("zoomPerson.join_time=======", new Date(zoomPerson.join_time).getTime())
        //                                    console.log("zoomPerson.leave_time=======", new Date(zoomPerson.leave_time).getTime())
        //                                    tempSessionData.forEach(function(arrayItem) {


        //                                        console.log("arrayItem.JoinTime=======", arrayItem.JoinTime)

        //                                        console.log("arrayItem.LeaveTime=======", arrayItem.LeaveTime)



        //                                        // if((arrayItem.JoinTime >= new Date(zoomPerson.join_time).getTime() && arrayItem.JoinTime < new Date(zoomPerson.leave_time).getTime()) || (arrayItem.LeaveTime >= new Date(zoomPerson.join_time).getTime() && arrayItem.LeaveTime < new Date(zoomPerson.leave_time).getTime())){
        //                                        // 	duplicateFlg = false;
        //                                        // }
        //                                    })
        //                                }
        //                                tempSessionData.forEach(function(arrayItem) {

        //                                    if ((new Date(zoomPerson.join_time).getTime() >= arrayItem.JoinTime && new Date(zoomPerson.leave_time).getTime() < arrayItem.JoinTime) || (new Date(zoomPerson.join_time).getTime() >= arrayItem.LeaveTime && new Date(zoomPerson.leave_time).getTime() < arrayItem.LeaveTime)) {
        //                                        duplicateFlg = false;
        //                                    }
        //                                })
        //                            }
        //                            if (duplicateFlg) {
        //                                tempCSVDetails.push({
        //                                    "CourseName": session.eventName,
        //                                    "MeetingID": session.ZoomMeetingId,
        //                                    "SessionName": session.Name,
        //                                    "StartTime": moment(new Date(session.StartDate._seconds * 1000))
        //                                        .tz("Asia/Singapore")
        //                                        .format("DD/MM/YYYY hh:mm A"),
        //                                    "EndTime": moment(new Date(session.EndDate._seconds * 1000))
        //                                        .tz("Asia/Singapore")
        //                                        .format("DD/MM/YYYY hh:mm A"),
        //                                    // Topic: session.Name,
        //                                    Name: zoomPerson.name,
        //                                    "UserEmail": zoomPerson.user_email,
        //                                    "Type": session.Zoom_Detail != undefined ? session.Zoom_Detail.host_email == zoomPerson.user_email ? 'Teacher' : 'Student' : 'NA',
        //                                    "JoinTime": new Date(zoomPerson.join_time).getTime(),
        //                                    "LeaveTime": new Date(zoomPerson.leave_time).getTime(),
        //                                    "Duration(Minutes)": Math.trunc(zoomPerson.duration / 60),
        //                                    "SessionDuration": resultInMinutes
        //                                });

        //                                finalCSVDetails.push({
        //                                    "Course Name": session.eventName,
        //                                    "Meeting ID": session.ZoomMeetingId,
        //                                    "Session Name": session.Name,
        //                                    "Start Time": moment(new Date(session.StartDate._seconds * 1000))
        //                                        .tz("Asia/Singapore")
        //                                        .format("DD/MM/YYYY hh:mm A"),
        //                                    "End Time": moment(new Date(session.EndDate._seconds * 1000))
        //                                        .tz("Asia/Singapore")
        //                                        .format("DD/MM/YYYY hh:mm A"),
        //                                    // Topic: session.Name,
        //                                    Name: zoomPerson.name,
        //                                    "User Email": zoomPerson.user_email,
        //                                    "Type": session.Zoom_Detail != undefined ? session.Zoom_Detail.host_email == zoomPerson.user_email ? 'Teacher' : 'Student' : 'NA',
        //                                    "Join Time": moment(new Date(zoomPerson.join_time))
        //                                        .tz("Asia/Singapore")
        //                                        .format("DD/MM/YYYY hh:mm A"),
        //                                    "Leave Time": moment(new Date(zoomPerson.leave_time))
        //                                        .tz("Asia/Singapore")
        //                                        .format("DD/MM/YYYY hh:mm A"),
        //                                    "Duration (Minutes)": Math.trunc(zoomPerson.duration / 60),
        //                                    "Session Duration": resultInMinutes
        //                                });
        //                            }

        //                        }
        //                    });
        //                }
        //            }
        //            //console.log("finalCSVDetails===",finalCSVDetails);
        //            finalCSVDetails.sort((a, b) => {
        //                let fa = a['Start Time'];
        //                let fb = b['Start Time'];
        //                if (fa < fb) {
        //                    return -1;
        //                }
        //                if (fa > fb) {
        //                    return 1;
        //                }
        //                return 0;
        //            });
        //            //const csv = parse(finalCSVDetails);
        //            //            const msg = {
        //            //                to: toEmail,
        //            //                from: {
        //            //                    email: "booking@edulife.sg",
        //            //                    name: `Edulife`,
        //            //                },
        //            //                bcc: "debayan.ghosh@webspiders.com",
        //            //                subject: "Sessions Report for " +
        //            //                    moment(new Date().getTime() - payload.time * 60 * 60 * 1000)
        //            //                    .tz("Asia/Singapore")
        //            //                    .format("MMMM DD, YYYY"),
        //            //                html: `<html><body><p>Dear Admin,</p></br>Please find the Sessions report for  last ${
        //            //	payload.time == 24
        //            //		? "24 hours "
        //            //		: payload.time == 168
        //            //		? "1 week "
        //            //		: payload.time == 720
        //            //		? "1 month"
        //            //		: ""
        //            //} attached herewith.</br></br><p>Thank you! </p></br>Team EduLife</body></ html>`,
        //            //                attachments: [{
        //            //                    content: new Buffer.from(csv).toString("base64"),
        //            //                    filename: "sessionDetails.csv",
        //            //                    type: "text/csv",
        //            //                    disposition: "attachment",
        //            //                }, ],
        //            //            };
        //            //sendMail(msg);
        //            resolve("Usage Details Sent");
        //        } catch (e) {
        //            reject(e);
        //        }
        //    });
        //}
    }
}